import TextArea from '../../base/Textarea/Textarea';

interface INotesRowProps {
  description: string | null | undefined;
}

const NotesRow = ({ description }: INotesRowProps) => {
  if (!description) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="text-primary flex items-center gap-1 text-lg font-semibold">Note</div>
      <TextArea isReadOnly value={description} rows={5} />
    </div>
  );
};

export default NotesRow;
